import Link from '@ui/components/Link/Link';
import Icon from '@ui/components/icon/icon';
import * as styles from './MobileMenu.styles';

type MobileMenuLinkProps = {
  className?: string;
  name?: string;
  title?: string;
  slug: string;
  showArrow?: boolean;
  openInNewTab?: null | boolean;
  onClose: () => void;
  onClick?: (name: string) => Promise<void>;
};

export default function MobileMenuNavigationLink({
  className,
  name,
  title,
  slug,
  showArrow,
  openInNewTab,
  onClose,
  onClick,
}: MobileMenuLinkProps) {
  if (!title) return null;
  return (
    <div>
      <Link
        href={slug}
        className={styles.mobileMenuButtonStyle({ className })}
        onClick={(event) => {
          if (onClick && name) {
            event.preventDefault();
            onClick(name ?? '');
          } else {
            onClose();
          }
        }}
        target={openInNewTab ? '_blank' : undefined}>
        {title}
        {showArrow && <Icon name="rightArrow" color="black" size={12} />}
      </Link>
    </div>
  );
}
